/* One interruptible accordion motion for both product pages and outfit previews. */
window.NHNYDropdowns = function(root) {
 const folds=[...root.querySelectorAll('.product-fold')];
 const states=new WeakMap();
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function set(fold,open) {
  const previous=states.get(fold);
  const start=fold.getBoundingClientRect().height;
  previous?.animation?.cancel();
  const summary=fold.querySelector('summary');
  summary.setAttribute('aria-expanded',String(open));
  fold.classList.toggle('is-expanded',open);
  fold.style.height='';fold.style.overflow='';
  if(reduced.matches){fold.open=open;states.delete(fold);return;}
  fold.open=true;
  const expanded=fold.getBoundingClientRect().height;
  const border=parseFloat(getComputedStyle(fold).borderTopWidth)+parseFloat(getComputedStyle(fold).borderBottomWidth);
  const end=open?expanded:summary.getBoundingClientRect().height+border;
  fold.style.overflow='hidden';
  const distance=Math.abs(end-start);
  const duration=Math.max(100,Math.min(open?280:210,distance*1.3));
  const animation=fold.animate([{height:start+'px'},{height:end+'px'}],{duration,easing:open?'cubic-bezier(.22,.65,.3,1)':'cubic-bezier(.4,0,.6,1)',fill:'both'});
  const state={open,animation};states.set(fold,state);
  animation.finished.then(()=>{
   if(states.get(fold)!==state)return;
   fold.open=open;animation.cancel();fold.style.overflow='';states.delete(fold);
  }).catch(()=>{});
 }
 folds.forEach(fold=>{
  const summary=fold.querySelector('summary');
  summary.setAttribute('aria-expanded',String(fold.open));
  fold.classList.toggle('is-expanded',fold.open);
  summary.addEventListener('click',event=>{
   event.preventDefault();
   const open=!(states.get(fold)?.open??fold.open);
   if(open)folds.filter(other=>other!==fold&&(states.get(other)?.open??other.open)).forEach(other=>set(other,false));
   set(fold,open);
  });
 });
};
